import React from 'react'
import PropTypes from 'prop-types'

import { MONTHS } from 'ar/constants'

/**
 * Renders month select.
 *
 * @param {Object} props
 * @return {*}
 * @constructor
 */
export function MonthSelect (props) {
  const { form, label, name, className, months } = props
  return (
    <div className={className}>
      <label>{label}</label>
      <select
        className={form.getInputClass(name)}
        required={true}
        name={name}
        value={form.getValue(name)}
        onChange={form.onChange}
      >
        <option value=''/>
        {months.map(m => (
          <option key={m} value={m}>{m}</option>
        ))}
      </select>
      {form.renderErrors(name)}
    </div>
  )
}

/**
 * Component properties.
 *
 * @type {{}}
 */
MonthSelect.propTypes = {
  form: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  months: PropTypes.array
}

/**
 * Component props default values.
 *
 * @type {{}}
 */
MonthSelect.defaultProps = {
  months: MONTHS
}
